var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53337 1.3776C4.69485 1.3776 3.21545 2.89582 3.21545 4.7665C3.21545 6.5877 4.60832 8.06538 6.36692 8.14515C6.47356 8.13758 6.58623 8.13721 6.69252 8.14508C8.44938 8.06446 9.8431 6.58776 9.85128 4.7651C9.85054 2.89607 8.36342 1.3776 6.53337 1.3776ZM1.8667 4.7665C1.8667 2.13701 3.94798 0 6.53337 0C9.10877 0 11.2 2.136 11.2 4.7665L11.2 4.76937C11.1895 7.34125 9.20474 9.43742 6.69989 9.52342C6.66994 9.52445 6.63995 9.52344 6.61013 9.52039C6.56677 9.51596 6.50198 9.51537 6.44156 9.52098C6.41374 9.52356 6.38578 9.52438 6.35785 9.52342C3.85349 9.43744 1.8667 7.34112 1.8667 4.7665Z",
    fill: "#347AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00693 10.4762C8.78995 10.4762 10.6082 10.9315 12.0133 11.8864C13.2764 12.7417 14 13.9407 14 15.231C14 16.5213 13.2765 17.7224 12.0139 18.5824L12.0138 18.5825C10.6044 19.542 8.78383 20 7 20C5.21652 20 3.39635 19.5422 1.98702 18.583C0.723773 17.7277 0 16.5285 0 15.2381C0 13.9479 0.723526 12.7467 1.98606 11.8868L1.98861 11.885L1.98861 11.8851C3.40196 10.9316 5.2237 10.4762 7.00693 10.4762ZM2.75639 13.0604C1.78207 13.7245 1.38705 14.527 1.38705 15.2381C1.38705 15.9491 1.78191 16.7491 2.75601 17.4085L2.75753 17.4095C3.89102 18.1812 5.42716 18.5887 7 18.5887C8.57278 18.5887 10.1089 18.1812 11.2423 17.4096C12.2176 16.7453 12.6129 15.9425 12.6129 15.231C12.6129 14.52 12.2181 13.72 11.244 13.0607L11.243 13.06C10.1144 12.2931 8.58059 11.8875 7.00693 11.8875C5.43408 11.8875 3.89509 12.2927 2.75639 13.0604Z",
    fill: "#347AF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.f79dbb5c2e98114a67f21ca7e9727e54.svg";
export { ForwardRef as ReactComponent };